import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IGenericMotivoResult from "../../../../interfaces/IGenericMotivoResult";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import InputDocumento from "../../../../components/hookForms/inputDocumento";
import InputNumber from "../../../../components/hookForms/inputNumber";
import InputText from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceConcessionaria from "../../../../services/serviceConcessionaria";
import serviceMotivoMovimentacaoInstalacao from "../../../../services/serviceMotivoMovimentacaoInstalacao";
import serviceRebalanceMovimentacaoInstalacao from "../../../../services/serviceRebalanceMovimentacaoInstalacao";
import serviceUsina from "../../../../services/serviceUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import DatePickerMui from "@/components/hookForms/datePicker";
import { format, isFuture, isValid, startOfDay } from "date-fns";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

export default function DialogNew({ open, onClose, onSuccess }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [motivoDataOptions, setMotivoDataOptions] = useState<IGenericMotivoResult[]>([]);
    const [typeDocument, setTypeDocument] = useState("");
    const [reasonType, setReasonType] = useState("");
    const [isDisable, setDisable] = useState(false);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            cotaAlterada: null,
            cotaAtual: null,
            nomeCliente: "",
            numeroDocumentoCliente: "",
            numeroInstalacao: "",
            observacao: "",
            status: "",
            tipoCiclo: "",
            tipoDocumentoCliente: "",
            rebalanceMotivoMovimentacaoInstalacaoID: null,
            usinaID: null,
            concessionariaID: null,
            cicloFaturamento: "",
            cicloFaturamentoFinal: "",
            dataVenda: null,
            percentualDescontoContratado: null,
        },
    });

    function handleChange(e: any) {
        if (e && e.tipo) {
            setReasonType(e.tipo);
        }
        if (e === "CNPJ" || e === "CPF") {
            setTypeDocument(e);
        }
    }

    const tipoDocumentoOptions = [
        { label: "CPF", value: "CPF" },
        { label: "CNPJ", value: "CNPJ" },
    ];

    const tipoMovimentacaoOptions = [
        { label: "Comercial", value: "Comercial" },
        { label: "Pós venda", value: "Pós venda" },
        { label: "Financeiro", value: "Financeiro" },
        { label: "Pré-Faturamento", value: "Pré-Faturamento" },
    ];

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    useEffect(() => {
        setMotivoData();
    }, []);

    const setMotivoData = async () => {
        serviceMotivoMovimentacaoInstalacao
            .getMotivos()
            .then((result) => {
                setMotivoDataOptions(result?.data);
            })
            .catch(() => {
                setMotivoDataOptions([]);
            });
    };

    const onCancelNew = () => {
        reset();
        onClose(true);
    };

    const validate = (values: any) => {
        if (!values.cicloFaturamento) {
            toast.error("O campo CICLO - DE deve ser informado");
            return false;
        }
        if (!values.tipoCiclo) {
            toast.error("O campo TIPO CICLO deve ser informado");
            return false;
        }
        if (!values.numeroInstalacao) {
            toast.error("O campo INSTALAÇÃO deve ser informado");
            return false;
        }
        if (!values.rebalanceMotivoMovimentacaoInstalacaoID) {
            toast.error("O campo MOTIVO deve ser informado");
            return false;
        }
        if (!values.concessionariaID) {
            toast.error("O campo Concessionária deve ser informado");
            return false;
        }
        if (reasonType) {
            if (reasonType === "I") {
                if (!values.concessionariaID) {
                    toast.error("O campo CONCESSIONARIA deve ser informado");
                    return false;
                }
                if (!values.tipoDocumentoCliente) {
                    toast.error("O campo TIPO DE DOCUMENTO deve ser informado");
                    return false;
                }
                if (values.tipoDocumentoCliente) {
                    var tipoDocumento = values.tipoDocumentoCliente;
                    var documento = values.numeroDocumentoCliente.replace(/[^A-Z0-9]/g, "");

                    if (!values.numeroDocumentoCliente) {
                        toast.error("O campo DOCUMENTO deve ser informado");
                        return false;
                    }
                    if (tipoDocumento === "F" && !/^\d{11}$/.test(documento)) {
                        toast.error("Número de CPF inválido");
                        return false;
                    }
                    // CNPJ alfanumérico: 12 primeiras posições aceitam letras ou dígitos,
                    // os 2 dígitos verificadores finais continuam numéricos.
                    if (tipoDocumento === "J" && !/^[A-Z0-9]{12}\d{2}$/.test(documento)) {
                        toast.error("Número de CNPJ inválido");
                        return false;
                    }
                }
                if (!values.nomeCliente) {
                    toast.error("O campo NOME CLIENTE deve ser informado");
                    return false;
                }
                if (!values.observacao) {
                    toast.error("O campo OBSERVAÇÃO deve ser informado");
                    return false;
                }
                // Obrigatórios apenas para motivo de inclusão — nos demais tipos o backend aceita nulo.
                if (!values.dataVenda) {
                    toast.error("O campo DATA DA VENDA deve ser informado");
                    return false;
                }
                if (values.percentualDescontoContratado === null) {
                    toast.error("O campo DESCONTO CONTRATADO deve ser informado");
                    return false;
                }
            }
            if (reasonType === "A" || reasonType === "I") {
                if (!values.cotaAtual) {
                    toast.error("O campo COTA ATUAL deve ser informado");
                    return false;
                }
                if (!values.cotaAlterada) {
                    toast.error("O campo COTA ALTERADA deve ser informado");
                    return false;
                }
            }
        }
        if (
            values.percentualDescontoContratado !== null &&
            (values.percentualDescontoContratado < 0 || values.percentualDescontoContratado > 100)
        ) {
            toast.error("O campo DESCONTO CONTRATADO deve estar entre 0 e 100");
            return false;
        }
        return true;
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        if (values.dataVenda && !isValid(values.dataVenda)) {
            toast.error("O campo DATA DA VENDA está em formato inválido. Formato esperado: 'dd/mm/aaaa'");
            setDisable(false);
            return;
        }
        if (values.dataVenda && isFuture(startOfDay(values.dataVenda))) {
            toast.error("O campo DATA DA VENDA não pode ser uma data futura");
            setDisable(false);
            return;
        }

        const treatedValues = {
            ...values,
            ativo: "S",
            cotaAtual: values.cotaAtual ? Number(values.cotaAtual.replaceAll(".", "").replaceAll(",", ".")) : null,
            cotaAlterada: values.cotaAlterada
                ? Number(values.cotaAlterada.replaceAll(".", "").replaceAll(",", "."))
                : null,
            numeroDocumentoCliente: values.numeroDocumentoCliente
                ? values.numeroDocumentoCliente.replace(/[^a-zA-Z0-9]/g, "").toUpperCase()
                : "",
            tipoCiclo:
                values.tipoCiclo === "Comercial"
                    ? "C"
                    : values.tipoCiclo === "Financeiro"
                    ? "F"
                    : values.tipoCiclo === "Pós venda"
                    ? "P"
                    : values.tipoCiclo === "Pré-Faturamento"
                    ? "M"
                    : "",
            status: "A", //Aberto
            tipoDocumentoCliente:
                values.tipoDocumentoCliente === "CPF" ? "F" : values.tipoDocumentoCliente === "CNPJ" ? "J" : "",
            numeroInstalacao: values.numeroInstalacao.toString(),
            usinaID: values.usinaID ? Number(values.usinaID) : null,
            cicloFaturamento: values.cicloFaturamento ? format(values?.cicloFaturamento, "MM/yyyy") : "",
            cicloFaturamentoFinal: values.cicloFaturamentoFinal
                ? format(values?.cicloFaturamentoFinal, "MM/yyyy")
                : null,
            dataVenda: values.dataVenda ? format(values.dataVenda, "dd/MM/yyyy") : null,
            percentualDescontoContratado: values.percentualDescontoContratado
                ? Number(values.percentualDescontoContratado.replaceAll(".", "").replaceAll(",", "."))
                : null,
        };

        if (validate(treatedValues)) {
            serviceRebalanceMovimentacaoInstalacao
                .create(treatedValues)
                .then((result) => {
                    if (result) {
                        toast.success(messages.createSucess);
                        onClose(true);
                        onSuccess();
                        reset();
                    }
                })
                .catch((err) => {
                    toast.error(messages.createError, err);
                })
                .finally(() => {
                    setDisable(false);
                });
        } else {
            setDisable(false);
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Nova movimentação
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelNew();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item md={6}>
                            <DatePickerMui
                                id="cicloFaturamento"
                                name="cicloFaturamento"
                                label="Ciclo - De"
                                format="MM/yyyy"
                                view={["month", "year"]}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <DatePickerMui
                                id="cicloFaturamentoFinal"
                                name="cicloFaturamentoFinal"
                                label="Ciclo - Até"
                                format="MM/yyyy"
                                view={["month", "year"]}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AutoComplete
                                id="tipoCiclo"
                                name="tipoCiclo"
                                label="Tipo"
                                control={control}
                                error={errors}
                                options={tipoMovimentacaoOptions}
                                concatWithID={true}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AutoComplete
                                id="concessionariaID"
                                name="concessionariaID"
                                label="Concessionária"
                                control={control}
                                error={errors}
                                options={concessionariaDataOptions}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AutoComplete
                                id="usinaID"
                                name="usinaID"
                                label="Usina"
                                options={usinaDataOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AutoComplete
                                id="tipoDocumentoCliente"
                                name="tipoDocumentoCliente"
                                label="Tipo de documento"
                                onChange={(e) => handleChange(e)}
                                control={control}
                                error={errors}
                                options={tipoDocumentoOptions}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <InputDocumento
                                id="numeroDocumentoCliente"
                                name="numeroDocumentoCliente"
                                label="Documento"
                                maxLength={typeDocument === "CPF" ? 11 : 14}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <InputNumber
                                id="numeroInstalacao"
                                name="numeroInstalacao"
                                label="Instalação"
                                decimalScale={0}
                                noThousandSeparator
                                maxLength={15}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <InputText
                                id="nomeCliente"
                                name="nomeCliente"
                                label="Nome cliente"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <InputNumber
                                id="cotaAtual"
                                name="cotaAtual"
                                label="Cota atual"
                                control={control}
                                error={errors}
                                decimalScale={2}
                                noThousandSeparator
                                maxLength={10}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <InputNumber
                                id="cotaAlterada"
                                name="cotaAlterada"
                                label="Cota alterada"
                                control={control}
                                error={errors}
                                decimalScale={2}
                                noThousandSeparator
                                maxLength={10}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <DatePickerMui
                                id="dataVenda"
                                name="dataVenda"
                                label="Data da venda"
                                format="dd/MM/yyyy"
                                noDateForward
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <InputNumber
                                id="percentualDescontoContratado"
                                name="percentualDescontoContratado"
                                label="Desconto contratado (%)"
                                control={control}
                                error={errors}
                                decimalScale={2}
                                noThousandSeparator
                                maxLength={6}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AutoComplete
                                id="rebalanceMotivoMovimentacaoInstalacaoID"
                                name="rebalanceMotivoMovimentacaoInstalacaoID"
                                label="Motivo"
                                onChange={(e) => handleChange(e)}
                                control={control}
                                error={errors}
                                options={motivoDataOptions}
                            />
                        </Grid>
                        <Grid item md={12}>
                            <InputText
                                id="observacao"
                                name="observacao"
                                label="Observação"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => {
                            onCancelNew();
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
